export default "__VITE_ASSET__AtBY1a4o__"